import globalStore from '@/store/global';
import { Watermark as AntDWartermark } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

const Watermark = ({ className, color = '#0000000d', children }) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    if(globalStore.userConfig.xid){
      setContent(globalStore.userConfig.xid);
    }
  }, [globalStore.userConfig.xid]);

  return (
    <AntDWartermark
      className={['size-full', className]}
      zIndex={1}
      font={{ color, fontSize: '12' }}
      gap={[200, 200]}
      content={[content, '内容由人工智能生成']}
    >
      {children}
    </AntDWartermark>
  );
};

export default observer(Watermark);
